import MathText from './MathText';

/**
 * Rendu du texte d'un coup de pouce, partagé par les deux supports qui
 * l'affichent : la bottom-sheet de l'espace élève et, depuis 2026-09-17, la
 * planche de cartes à découper de l'évaluation papier.
 *
 * Sorti VERBATIM de `pages/EspaceEleve/CoupDePouceSheet.jsx` (où il vivait en
 * privé) : mêmes expressions, mêmes couleurs, même ordre des branches. Le
 * déplacement ne change aucun comportement, il évite une seconde
 * implémentation côté impression — 303 des 490 pages imprimables du parc
 * portent du texte hors figure, dont 271 avec du gras (inventaire 2026-09-17).
 *
 * Le contenu des coups de pouce reste du TEXTE, jamais du HTML brut : c'est ce
 * qui le rend lisible tel quel par la synthèse vocale.
 */

/** **gras** → <strong>, ==rouge== → <strong> rouge (valeurs à faire
 *  ressortir, ex. quotient/reste — demande utilisateur 2026-08-01), et
 *  $...$ → KaTeX inline via MathText (vraies fractions dans les fiches,
 *  demande utilisateur 2026-08-01). Retourne un tableau de fragments React. */
export const renderInline = (texte) => String(texte).split(/(\*\*[^*]+\*\*|==[^=]+==)/g).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={i} style={{ color: '#0f172a' }}><MathText>{part.slice(2, -2)}</MathText></strong>;
    }
    if (part.startsWith('==') && part.endsWith('==')) {
        return <strong key={i} style={{ color: '#dc2626' }}><MathText>{part.slice(2, -2)}</MathText></strong>;
    }
    return <MathText key={i}>{part}</MathText>;
});

export default renderInline;
